import { IoChevronForward } from "react-icons/io5";
import { Link } from "react-router-dom";

const ProfileNavigation = ({ id }) => {
  const items = [
    {
      title: "Creditable Withholding Tax",
      description: "Manage 2307",
      url: `/accounts/${id}/creditables`,
    },
    {
      title: "Official Receipt",
      description: "Manage Official Receipt",
      url: `/accounts/${id}/receipts`,
    },
    {
      title: "Account Journal",
      description: "Manage Account Journal",
      url: `/accounts/journals/${id}`,
    },
    {
      title: "Account Reports",
      description: "Generate Reports",
      url: `/accounts/reports/${id}`,
    },
  ];

  return (
    <div className="card p-0">
      {items.map(({ title, description, url }, index) => (
        <div
          className="px-8 py-4 cursor-pointer hover:bg-gray-50 border-b last:border-b-0"
          key={index}
        >
          <Link className="flex items-center justify-between" to={url}>
            <div>
              <p className="text-gray-500 text-sm">{title}</p>
              <span className="text-sm text-gray-400">{description}</span>
            </div>
            <IoChevronForward className="text-blue-500" />
          </Link>
        </div>
      ))}
    </div>
  );
};

export default ProfileNavigation;
